import { render, staticRenderFns } from "./TabCourseexplanation.vue?vue&type=template&id=63ff4ee4"
import script from "../../../services/teacher/DetailCourseTab/tab-courseexplanation.js?vue&type=script&lang=js&external"
export * from "../../../services/teacher/DetailCourseTab/tab-courseexplanation.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports